import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

import ChatTopBar from "@/components/chat/chatContainer/ChatTopBar/ChatTopBar.vue";
import ChatInputBar from "@/components/chat/chatContainer/ChatInputBar/ChatInputBar.vue";
import ChatContent from "@/components/chat/chatContainer/ChatContent/ChatContent.vue";
import { useGetChatContentContainerProperties } from "./useGetChatContentContainerProperties";
import { computed } from "vue";
import { GetterTypes } from "@/store";
import MobileLayout from "@/components/layouts/MobileLayout.vue";
import ForwardMessageSelect from "../ForwardMessageSelect/ForwardMessageSelect.vue";
import { useComputedValue, useGetMessageHandlers } from "@/composables";
import { AppEnvironment, LayoutTypes } from "@/store/app/state";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatContentContainer',
  setup(__props) {

const { forwardedMessage } = useGetMessageHandlers();

const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const isMobile = computed(
  () =>
    layoutType.value === LayoutTypes.MOBILE && environment.value.isMobileApp,
);
const { root, style, isBlockingTextShown, messages, members } =
  useGetChatContentContainerProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(forwardedMessage) && isMobile.value)
      ? (_openBlock(), _createBlock(MobileLayout, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(ForwardMessageSelect)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(forwardedMessage))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "root",
          ref: root,
          class: _normalizeClass(["chat-wrapper", { isBlocking: _unref(isBlockingTextShown) }]),
          style: _normalizeStyle(_unref(style))
        }, [
          _createVNode(ChatTopBar),
          _createVNode(ChatContent, { messages: _unref(messages) }, null, 8, ["messages"]),
          (!_unref(isBlockingTextShown))
            ? (_openBlock(), _createBlock(ChatInputBar, {
                key: 0,
                members: _unref(members)
              }, null, 8, ["members"]))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true)
  ], 64))
}
}

})